import { styles } from "@material-ui/pickers/views/Calendar/Calendar";
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import "./style.css";
import swal from "sweetalert";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ManagePaginate from "../Component/paginate";
import AdminTable from "../Component/adminTable";
import { GridColumnsActionStyle, GridColumnsDateStyle, GridColumnsStyle, GridColumnsStyleStatus, GridHeaderStyle } from "../Component/constants";
import CustomSwitch from "../Component/customSwitch";
const Company = (props) => {
  let items = [];
  props?.data?.map((element) => {
    let status = element.is_active == 1 ? "Active" : "Inactive";
    items.push({
      id: element.id,
      name: element.name,
      email: element.email,
      department: element.departmentName,
      regionName: element.regionName,
      active: status,
      created_date: element.created_date,
      departmentID: element.department,
      regionID: element.region
    });
  });
  const [currentPage,setCurrentPage]=useState(1)
  const handlePageClick = (value) => {
    setCurrentPage(value.selected + 1)
    props.getAllCompanies(props.searchVal ? props.searchVal : "", value.selected + 1,10);
  };
  const handleRowsPerPageChange=(currentPage,rowsPerPage)=>{
    props.getAllCompanies(props.searchVal ? props.searchVal : "",currentPage,rowsPerPage);
  }

  const btnFormatter = (cell, row) => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* <button
            style={{
              color: "#ffffff",
              textDecoration: "underline",
              border: "none",
              padding: "10px",
              fontSize: "13px",
              width: "84px",
              backgroundColor: row.active == "Active" ? "#f90453" : "#4f2d7f",
              textDecoration: "none",
            }}
            onClick={() => {
              let txt = row.active == "Active" ? "Deactivate" : "Activate";
              swal({
                title: "Are you sure?",
                text: "Do you want to " + txt + " this Partner",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((msg) => {
                if (msg) {
                  props.deactivate(row);
                }
              });
            }}
          >
            {row.active == "Active" ? "Deactivate" : "Activate"}
          </button> */}
          <Tooltip
            title="Edit Partner"
            placement="top"
            onClick={() => props.openEditUserModal(row)}
          >
            <EditIcon
              style={{
                color: "#4f2d7f",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            />
          </Tooltip>
        </div>
      </>
    );
  };
  const columns = [
    {
      dataField: "name",
      text: "Partner Name",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style:GridColumnsStyle,
      headerStyle: GridHeaderStyle,
    },
    {
      dataField: "email",
      text: "Email",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style:GridColumnsStyle,
      headerStyle: GridHeaderStyle,
    },
    {
      dataField: "department",
      text: "Department Name",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style: GridColumnsStyle,
      headerStyle: GridHeaderStyle
    },
    {
      dataField: "regionName",
      text: "Region Name",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style: GridColumnsStyle,
      headerStyle: GridHeaderStyle,
    },
    {
      dataField: "",
      text: "Created Date-Time",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style: GridColumnsDateStyle,
      headerStyle: GridHeaderStyle,
      formatter: (cell, row) => {
        let formattedDate = "NA";
        if (row.created_date) {
          formattedDate = moment(row.created_date).format(
            "DD/MM/YYYY HH:mm:ss"
          );
        }
        return (
          <a
            href={"/company/" + row.id}
            style={{ textDecoration: "none", color: "black" }}
          >
            {formattedDate}
          </a>
        );
      },
    },

    {
      dataField: "active",
      text: " Status",
      sort: true,
      sortCaret: (order, column) => {
        if (!order)
          return (
            <span style={{ color: "white" }}>&nbsp;&nbsp;&#8593;&#8595;</span>
          );
        else if (order == "asc")
          return (
            <span>
              &nbsp;&nbsp;<font style={{ color: "lawngreen" }}>&#8595;</font>
              <font style={{ color: "cornsilk" }}>&#8593;</font>
            </span>
          );
        else if (order == "desc")
          return (
            <span>
              &nbsp;&nbsp;<font style={{ color: "cornsilk" }}>&#8595;</font>
              <font style={{ color: "lawngreen" }}>&#8593;</font>
            </span>
          );
        return null;
      },
      style: GridColumnsStyleStatus,
      headerStyle: GridHeaderStyle,
      formatter: (cell, row) => {
        return <CustomSwitch
        isActivate={row.active == "Active"}
        label={"Partner"}
        onChange={props.deactivate}
        row={row}
      />
      },
    },
    {
      dataField: "id",
      text: "Action",
      style: GridColumnsActionStyle,
      headerStyle: GridHeaderStyle,
      formatter: btnFormatter,
    },
  ];
  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.backgroundColor = "#fff";
    return style;
  };

  return (
    <>
    <AdminTable
      keyField="id"
      data={items}
      columns={columns}
      rowsPerPage={props.rowsPerPage}
      currentPage={props.currentPage}
      totalRecords={props.totalRecords}
      onHandleTableChange={props.mainHandleRowsPerPageChange}
    />
  </>
  );
};

export default Company;
